// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"5f9401c7","453":"1d672efd","744":"47489e00","801":"c4fd3ad2"}[chunkId] + ".chunk.js";
};